export default __webpack_public_path__ + "bdddc5a278e2074be5ec19558dc145b2.png";